import { connect } from 'react-redux'
import * as processAction from '../../state/instance-detail/action'
import * as processSelector from '../../state/instance-detail/selector'
import PatientScannedWidget from './PatientScannedWidget'

const mapStateToProps = (state, props) => {
    return {
        context: processSelector.selectProcessContext(state),
    }
}

const mapDispatchToProps = {
    changeProcessContext: processAction.changeProcessContext,
    saveProcessContext: processAction.saveProcessContext,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PatientScannedWidget)



// WEBPACK FOOTER //
// ./src/modules/process/component/task-widget/PatientScannedWidgetContainer.js